import {VejledersamtaleEnum} from "../../vejledning/vejledersamtaler/vejledersamtaleModel";
import {VejledersamtaleStatusEnum} from "../../vejledning/vejledersamtaler/VejledersamtaleStatusEnum";
import { nullableDateTimeStringFromApiToDate} from "../../../index";
import {VejledningDatoKategoriEnum} from "./VejledningDatoKategoriEnum";

export class DashboardVejledersamtaleModel {
    brugerId: string;
    forloebId: string;
    vejledersamtaleId: string;
    vejledersamtaleType: VejledersamtaleEnum;
    afholdtDato?: Date;
    status: VejledersamtaleStatusEnum;
    datoKategori: VejledningDatoKategoriEnum;

    static Build(responseModel: DashboardVejledersamtaleResponseModel): DashboardVejledersamtaleModel {
        let model = new DashboardVejledersamtaleModel();
        model.brugerId = responseModel.brugerId;
        model.forloebId = responseModel.forloebId;
        model.vejledersamtaleId = responseModel.vejledersamtaleId;
        model.vejledersamtaleType = responseModel.vejledersamtaleType;
        model.afholdtDato = nullableDateTimeStringFromApiToDate(responseModel.afholdtDato);
        model.status = responseModel.status;
        model.datoKategori = responseModel.datoKategori;
        return model;
    }
}

export type DashboardVejledersamtaleResponseModel = {
    brugerId: string;
    forloebId: string;
    vejledersamtaleId: string;
    vejledersamtaleType: VejledersamtaleEnum;
    afholdtDato?: string;
    status: VejledersamtaleStatusEnum;
    datoKategori: VejledningDatoKategoriEnum;
}
